import { useState } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

import { CreateRiskRegisterForm } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/CreateRiskRegisterModal/components/CreateRiskRegisterForm/CreateRiskRegisterForm';

export const CreateRiskRegisterModal = () => {
    const [showModal, setShowModal] = useState(true);
    const { pathname, search } = useLocation();
    const history = useHistory();

    const handleModalClose = () => {
        setShowModal(false);
        const pathWithoutParams = pathname.slice(0, pathname.lastIndexOf('/'));

        history.push({
            pathname: pathWithoutParams,
            search: search,
        });
    };
    return <CreateRiskRegisterForm open={showModal} onClose={handleModalClose} />;
};
